module.exports = __webpack_public_path__ + "img/fr_last_edit_btn2.d1401bc4.png";